export function initManageCookies() {
  const wrapper = document.querySelector('.manage-cookies-wrapper');
  if (!wrapper) return;

  const toggles = wrapper.querySelectorAll('.manage-cookies__item-toggle');
  toggles.forEach((btn) => {
    btn.addEventListener('click', () => {
      const item = btn.closest('.manage-cookies__item');
      if (!item) return;
      const isExpanded = item.classList.toggle('manage-cookies__item--expanded');
      btn.setAttribute('aria-expanded', isExpanded);
    });
  });
}
